import type { Incident, Unschedule } from "../models/Incidents.ts";

export function getIncidentRecordBranchId(record: Incident): number {
  const schedule = record?.schedule as
    | {
        branchId?: number;
        branch?: { id?: number };
        partner?: { candidate?: { branch?: { id?: number } } };
      }
    | undefined;

  const fromSchedule = Number(
    schedule?.branchId ?? schedule?.branch?.id ?? 0
  );
  if (fromSchedule > 0) {
    return fromSchedule;
  }

  return Number(schedule?.partner?.candidate?.branch?.id ?? 0);
}

export function getUnscheduleBranchId(unschedule: Unschedule): number {
  const row = unschedule as Unschedule & {
    branchId?: number;
    branch?: { id?: number };
  };
  const direct = Number(row.branchId ?? row.branch?.id ?? 0);
  if (direct > 0) {
    return direct;
  }
  return Number(unschedule.partner?.candidate?.branch?.id ?? 0);
}

/** Registro sintético para parear checadas no programadas como en RowIncident. */
export function buildUnscheduleIncidentRecord(
  unschedule: Unschedule,
  operationDate?: string
) {
  const branchId = getUnscheduleBranchId(unschedule);
  const exactDate =
    operationDate ||
    (unschedule.checkIn?.checkDate
      ? String(unschedule.checkIn.checkDate).slice(0, 10)
      : "");

  return {
    checkIn: unschedule.checkIn,
    checkOut: unschedule.checkOut,
    schedule: {
      exactDate,
      partner: unschedule.partner,
      branchId,
      branch: unschedule.branch,
      checks: unschedule.checks ?? [],
    },
  };
}

export function collectIncidentBranchIds(
  records: Incident[],
  unschedule: Unschedule[],
  extraBranchIds: number[] = []
): number[] {
  const ids = new Set<number>();
  for (const record of records || []) {
    const branchId = getIncidentRecordBranchId(record);
    if (branchId > 0) {
      ids.add(branchId);
    }
  }
  for (const row of unschedule || []) {
    const branchId = getUnscheduleBranchId(row);
    if (branchId > 0) {
      ids.add(branchId);
    }
  }
  for (const id of extraBranchIds) {
    const branchId = Number(id);
    if (branchId > 0) {
      ids.add(branchId);
    }
  }
  return [...ids].sort((a, b) => a - b);
}
